// extracted by mini-css-extract-plugin
export default {"label":"fields_label__uPDJF","on-focus":"fields_on-focus__T1ib9"};